import { createAction } from '@reduxjs/toolkit';
import { RootServices } from '../../services';

export const setServices = createAction<RootServices>('dependency/setServices');
